/**
 * Enum for URLs for the API endpoints.
 */
import root from 'window-or-global';
import {getPageNoLeadingSlash} from 'epic-node-cms/src/cmsUtils/utils';

export default function url() {
    /**
     * Enum for URLs for the API endpoints.
     */
    let appContext = '';
    if (root.appContext && root.appContext !== '/') {
        ({appContext} = root);
    }

    const {location} = root;

    if (!location.origin) {
        const port = location.port ? `:${location.port}` : '';
        location.origin = `${location.protocol}//${location.hostname}${port}`;
    }
    const origin = location.origin + appContext;

    const url = {
        CMS_PAGE_DATA: (locale, urlPattern) => `${origin}/api/${locale}/cms/${getPageNoLeadingSlash(urlPattern)}`
    };

    return url;
}
